import React, { useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import sortBy from 'lodash/sortBy';

import makeStyles from '@mui/styles/makeStyles';
import Box from '@mui/material/Box';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';

import CircularProgress from '@mui/material/CircularProgress';

const useStyles = makeStyles(() => ({
  waitingOverlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(255, 255, 255, 0.4)',
  },
}));

const WaitingOverlay = () => {
  const classes = useStyles();
  return (
    <Box
      className={classes.waitingOverlay}
      display="flex"
      alignItems="center"
      justifyContent="flex-end"
      px={3}
    >
      <CircularProgress size={16} />
    </Box>
  );
};

const CourseSelector = (props) => {
  const {
    className,
    courses: inputCourses,
    loading,
    selectedCourseId,
    label,
    onSelectCourse,
  } = props;

  const handleSelectCourse = useCallback(
    (event) => {
      onSelectCourse(event.target.value);
    },
    [onSelectCourse]
  );

  const courses = useMemo(() => {
    return sortBy(inputCourses, (course) => course.name.toUpperCase());
  }, [inputCourses]);

  return (
    <Box position="relative" width="100%">
      <FormControl fullWidth className={className} disabled={loading}>
        <InputLabel htmlFor="simple-select">{label}</InputLabel>
        <Select onChange={handleSelectCourse} value={selectedCourseId}>
          {courses.map((course) => (
            <MenuItem key={course._id} value={course._id}>
              {course.name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      {loading && <WaitingOverlay />}
    </Box>
  );
};

CourseSelector.propTypes = {
  className: PropTypes.string,
  courses: PropTypes.array,
  loading: PropTypes.bool,
  selectedCourseId: PropTypes.string,
  label: PropTypes.node,

  onSelectCourse: PropTypes.func,
};

CourseSelector.defaultProps = {
  className: undefined,
  courses: [],
  loading: false,
  selectedCourseId: '',
  label: <FormattedMessage id="courseSelector.label" />,

  onSelectCourse() {},
};

export default CourseSelector;
